import cn from 'classnames'
import { formatMoneyInteger } from 'legacy/lut/components/widgets/public/partner360/helpers/formatMoneyInteger'

import { TPopupHorizontal } from 'core-components/library/popup'
import { Tooltip } from 'core-components/library/tooltip'

import styles from '../../CategoryPlanning.module.scss'
import { actualsDirectColor, actualsIndirectColor } from '../../config'
import { getDivisor } from '../../helpers/getDivisor'
import { getFractionDigits } from '../../helpers/getFractionDigits'

// SMB vs EU split: SMB and EU are independent rows in the data, each is rendered as is.
// They are not derived from the Total row and are not expected to add up to it, and any
// of them can be missing - a missing value is shown as no data.
export const smbVsEuWrapper = (
  smbValue: number,
  euValue: number,
  rounding: string = '',
  tip: string = ''
) => {
  const divisor = getDivisor(rounding)
  const roundingFractionDigits = getFractionDigits(rounding)
  const fractionDigits = roundingFractionDigits || 0

  const format = (value: number) =>
    value === null || value === undefined ? '-' : formatMoneyInteger(value, fractionDigits, divisor)

  return (
    <Tooltip
      inline
      tipContent={() => (
        <div className={styles.productLineTip}>
          <span>{tip}</span>
        </div>
      )}
      horizontalStartPosition={TPopupHorizontal.Center}
      horizontalDirection={TPopupHorizontal.Center}
      disabled={!tip}
    >
      <div className={cn({ [styles.valueTip]: tip })} style={{ color: actualsDirectColor }}>
        {format(smbValue)}
      </div>
      <div className={cn({ [styles.valueTip]: tip })} style={{ color: actualsIndirectColor }}>
        {format(euValue)}
      </div>
    </Tooltip>
  )
}
